import { measure } from 'atomic-timing'
import createHistory from 'history/createBrowserHistory'
import * as React from 'react'
import { hydrate } from 'react-dom'
import * as Loadable from 'react-loadable'

import { clientFinishedLoading } from '../common/actions/common'
import { reportPerformanceMetrics } from '../common/analytics'
import configureStore from '../common/store/configureStore'
import domLoaded from '../common/utils/domLoaded'
import legacyAffiliates from '../common/utils/legacyAffiliates'
import App from './app'

import '../assets/stylesheets/style.css'
import './index.css'

const history = createHistory()

try {
  measure()
    .then(reportPerformanceMetrics)
    .catch(() => {})
} catch (e) {}

// this only runs on initial hydrating
const initialState = (window as any).INITIAL_STATE
delete (window as any).INITIAL_STATE

const store = configureStore(initialState, history)

legacyAffiliates(window.location)

async function main() {
  await Loadable.preloadReady()
  await domLoaded()

  hydrate(
    <App store={store} history={history} />,
    document.querySelector('#react-view'),
    () => {
      store.dispatch(clientFinishedLoading())
    }
  )
}

main()
